module.exports = __webpack_public_path__ + "images/logoutIcon-bcfdb2a6e18400ca40d6ab764d3a5507.svg";